// extracted by mini-css-extract-plugin
var _1 = "DashboardBirdview-moduledashboard__ZKY1x";
export { _1 as "dashboard" }
